module.exports = __webpack_public_path__ + "img/sintoma em ponto de queda de folha.a4d066cc.webp";